const variants = {
  primary:
    'border-transparent bg-[var(--accent-green)] text-white hover:bg-[var(--accent-green-dark)]',
  outline:
    'border-[var(--accent-gold)] text-[var(--accent-gold)] hover:bg-[var(--accent-gold)] hover:text-neutral-950',
  tag:
    'border-[var(--accent-green)] text-[var(--accent-green)] hover:bg-[var(--accent-green)] hover:text-white',
  tagActive:
    'border-[var(--accent-green)] bg-[var(--accent-green)] text-white',
};

function Button({ as: Component = 'button', variant = 'primary', className = '', children, ...props }) {
  const typeProps = Component === 'button' && !props.type ? { type: 'button' } : {};

  return (
    <Component
      className={`inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent-gold)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-primary)] ${variants[variant]} ${className}`}
      {...typeProps}
      {...props}
    >
      {children}
    </Component>
  );
}

export default Button;
